import React, { FC } from 'react';

import { formatCurrency } from 'utils/currency';
import {
  isPendingHourlyPayout,
  PendingHourlyPayoutRecord,
} from 'utils/bumpApproval';

type PayoutAmountRecord = PendingHourlyPayoutRecord & {
  calculateCost: number | string | null;
};

type PayoutAmountProps = {
  record?: PayoutAmountRecord;
};

/**
 * Currency-formatted payout / calculated cost cell, greyed out while an
 * hourly payout is still estimate-based (hours not yet approved).
 */
export const PayoutAmount: FC<PayoutAmountProps> = ({ record }) => {
  const amount = formatCurrency(record?.calculateCost, '-');
  return isPendingHourlyPayout(record) ? (
    <span style={{ color: 'rgba(0, 0, 0, 0.38)' }}>{amount}</span>
  ) : (
    <>{amount}</>
  );
};
